<template>
  <div>
    <el-dialog
      title="选择标签"
      v-dialogDrag
      :visible.sync="dialogFormVisible"
      @close="close"
      width="500px"
    >
      <el-form
        :model="dataObj"
        :rules="rules"
        size="small"
        ref="ruleForm"
        label-position="right"
        label-width="110px"
      >
        <el-form-item label="标签" prop="labelId">
          <el-select
            v-model="dataObj.labelId"
            clearable
            filterable
            placeholder="请选择"
            class="input-width-two"
            @change="editLabel"
            :disabled="isEdit"
          >
            <el-option
              v-for="(val, key, i) in dropList.labelConfigList"
              :label="val"
              :value="$downToInteger(key)"
              :key="i"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="新增标签" prop="name">
          <el-input
            v-model="dataObj.name"
            clearable
            :disabled="isAdd"
            class="input-width-two"
            @change="addLabel"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="标签颜色" prop="color">
          <el-color-picker
            class="theme-picker"
            :predefine="[
              '#409EFF',
              '#1890ff',
              '#304156',
              '#212121',
              '#11a983',
              '#13c2c2',
              '#6959CD',
              '#f5222d',
            ]"
            v-model="dataObj.color"
          ></el-color-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          @click="dialogFormVisible = false"
          v-preventReClick="5000"
          :disabled="disabled"
          >取 消</el-button
        >
        <el-button
          type="primary"
          @click="checkEdit('ruleForm')"
          v-preventReClick="5000"
          :disabled="disabled"
          >确认</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
/**
 * 邮件标签选择/新增弹窗组件（Amazon 版）
 * 功能：支持选择已有标签（自动回填颜色）或新增标签（自定义名称+颜色），调用 addLabelsing/editaddLabelsing 接口保存
 */
import { addLabelsing, editaddLabelsing, getLabelConfigList } from "@/api/user";
export default {
  name: "edit",
  props: {
    scope: {
      type: Object,
      default: () => {
        return {};
      },
    },
    // 标签下拉数据
    labelConfigList: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      // 表单校验规则：标签颜色必选
      rules: {
        color: [
          { required: true, message: "请选择标签颜色", trigger: "change" },
        ],
      },
      // 标签表单数据：标签名、标签 id、颜色、邮件 id、标签配置 id
      dataObj: {
        name: "",
        labelId: "",
        color: "",
        messageId: "",
        configId: "",
      },
      // 按钮禁用状态（防止重复提交）
      disabled: false,
      // 是否已选择已有标签（新增标签输入框禁用）
      isAdd: false,
      // 是否已输入新增标签名（已有标签下拉禁用）
      isEdit: false,
      // 弹窗显示状态
      dialogFormVisible: true,
    };
  },
  created() {
    // 组件创建时回显当前邮件的标签数据
    this.handleClick();
  },
  computed: {
    dropList: {
      get() {
        return this.$store.getters.dropList;
      },
    },
  },
  methods: {
    /** 回显当前邮件的标签数据并拉取标签下拉 */
    handleClick() {
      // 获取标签下拉数据
      this.$store.dispatch("getDropListTwo", ["labelConfigList"]);
      this.isAdd = this.scope.labelId ? true : false;
      //   Object.assign(this.dataObj, this.scope);
      this.dataObj.messageId = this.scope.messageId;
      this.dataObj.color = this.scope.labelColor;
      this.dataObj.labelId = this.scope.labelId;
      this.dataObj.configId = this.scope.configId;
    },
    // 选择标签和新增标签二选一
    editLabel(val) {
      this.isAdd = val ? true : false;
      const label = this.labelConfigList[val];
      getLabelConfigList({ label: label }).then((res) => {
        if (res.code === 200) {
          this.dataObj.color=res.data.pageInfo.records[0].color
        }
      });
    },
    /** 输入新增标签名后切换编辑状态（已输入时禁用已有标签下拉） */
    addLabel() {
      this.isEdit = this.dataObj.name ? true : false;
    },
    /** 关闭弹窗并通知父组件 */
    close() {
      this.$emit("isShowEdit");
    },
    /**
     * 校验并保存标签（新增标签时调用 addLabelsing，选择已有标签时调用 editaddLabelsing）
     * @param {String} formName 表单 ref 名称
     */
    checkEdit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.dataObj.labelId === "" && this.dataObj.name === "") {
            this.$message.error("请选择标签或新增标签！");
            return false;
          }
          // ||this.dataObj.configId===""
          if (this.isEdit) {
            let { labelId, configId, ...obj } = this.dataObj;
            addLabelsing(obj).then((result) => {
              if (result.code == 200) {
                this.$message({
                  message: result.msg,
                  type: "success",
                });
                this.$emit("getList");
                this.$emit("isShowEdit");
              }
            });
          } else {
            let { name, ...obj } = this.dataObj;
            editaddLabelsing(obj).then((result) => {
              if (result.code == 200) {
                this.$message({
                  message: result.msg,
                  type: "success",
                });
                this.$emit("getList");
                this.$emit("isShowEdit");
              }
            });
          }
        }
      });
    },
  },
};
</script>